import CustomOffersPage from './CustomOffersPage'

export default CustomOffersPage